/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconAssign.vue?vue&type=template&id=1a18f95e"
import script from "./IconAssign.vue?vue&type=script&lang=js"
export * from "./IconAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a18f95e')) {
      api.createRecord('1a18f95e', component.options)
    } else {
      api.reload('1a18f95e', component.options)
    }
    module.hot.accept("./IconAssign.vue?vue&type=template&id=1a18f95e", function () {
      api.rerender('1a18f95e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconAssign.vue"
export default component.exports